export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover o endereço <b>${this.currentEntity.label}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/addresses/resources/computed.js